import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ForestryStatusCreateDto, ForestryStatusDto, ForestryStatusExcelDownloadDto, ForestryStatusUpdateDto, GetForestryStatusesInputDto } from '../dtos/forestry-status/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ForestryStatusService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: ForestryStatusCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ForestryStatusDto>({
      method: 'POST',
      url: '/api/planning/forestryStatuses',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/forestryStatuses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/forestryStatuses',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ForestryStatusDto>({
      method: 'GET',
      url: `/api/planning/forestryStatuses/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/forestryStatuses/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetForestryStatusesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ForestryStatusDto>>({
      method: 'GET',
      url: '/api/planning/forestryStatuses',
      params: { name: input.name, code: input.code, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ForestryStatusExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/forestryStatuses/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ForestryStatusDto[]>({
      method: 'GET',
      url: '/api/planning/forestryStatuses/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ForestryStatusUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ForestryStatusDto>({
      method: 'PUT',
      url: `/api/planning/forestryStatuses/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}